import { render, staticRenderFns } from "./Tema.comp.vue?vue&type=template&id=52f5bb91&"
import script from "./Tema.comp.vue?vue&type=script&lang=js&"
export * from "./Tema.comp.vue?vue&type=script&lang=js&"
import style0 from "./Tema.comp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports